<template>
	<div class="box">
		<div class="header">
			<div class="logo pointer" @click="return_">
				<img src="../../static/images/logo.png" alt="">
			</div>
			<div class="header_right">
				<img @click="return_" src="../../static/images/brand/guanbi.png" alt="">
			</div>
		</div>
		<div class="topkongbox"></div>
		<div class="main" :style="{ 'height': screenHeight + 'px' }">
			<div class="mainkongbox"></div>
			<h1>{{$t('m.login_01')}}</h1>
			<div class="zhuce">
				<div class="text1">{{$t('m.login_02')}}？</div>
				<div class="orange pointer" @click="register">{{$t('m.login_03')}}</div>
			</div>
			<div class="loginbox">
				<div class="loginbox_left">
					<div class="input_box">
						<div class="text">
							<span>{{$t('m.login_04')}}/{{$t('m.login_044')}}</span>
						</div>
						<div class="input" v-if="is_yx">
							<input type="text" v-model="user_data.email">
						</div>
						<div class="input" v-if="!is_yx">
							<input type="text" v-model="user_data.mobile">
						</div>
					</div>
					
					<div class="input_box input_box1">
						<div class="text">
							{{$t('m.login_05')}}
						</div>
						<div class="input">
							<input type="password" v-model="user_data.password">
						</div>
					</div>
					<div class="forget pointer" @click="RetrievePwd">
						{{$t('m.login_06')}}
					</div>
					<div class="btnbox">
						<el-button type="danger" @click="confirm">{{$t('m.login_01')}}</el-button>
					</div>
				</div>
				<div class="VerticalLine">
					<div class="xian"></div>
				</div>
				<div class="loginbox_right ">
					
					<!-- <div class="g_id_signin" id="g_id_signin"></div> -->
					
					<!-- 谷歌登录1 -->
					 <!-- <div
					 class="g_id_signin" 
					 id="g_id_signin"
					 ></div> -->
					
					
					
					<!-- 谷歌登录2 -->
					<!-- <g-signin-button
					    :params="googleSignInParams"
					    @success="onSignInSuccess_google"
					    @error="onSignInError_google">
					<div class="other pointer gugestyle">
						<div class="other_left border-right1">
							<img class="icon_01" src="../../static/images/brand/guge.png" alt="">
						</div>
						<div class="other_right">
							{{$t('m.login_07')}} Google {{$t('m.login_08')}}
						</div>
					</div>
					</g-signin-button> -->
					
					<!-- <button v-google-signin-button="clientId" class="google-signin-button"> Continue with Google</button> -->
					
					
					
					<!-- <div class="g-signin2" data-onsuccess="onSignIn">666</div> -->
					<!-- <div class="g_id_signin" id="g_id_signin">
						66
					</div> -->
					
					<!-- <div  style="position: relative;"> -->
						<!-- <div style="position: relative;z-index: 966999;top: 0;left: 0;opacity: 0;width: 260px;height: 50px;" 
						id="g_id_signin"></div> -->
						<div class="other pointer gugestyle" id="g_id_signin">
							<div class="other_left border-right1">
								<img class="icon_01" src="../../static/images/brand/guge.png" alt="">
							</div>
							<div class="other_right">
								{{$t('m.login_07')}} Google {{$t('m.login_08')}}
							</div>
						</div>
					<!-- </div> -->
					
					
					
					<!-- 脸书登录 -->
					<fb-signin-button
						  :params="fbSignInParams"
						  @success="onSignInSuccess"
						  @error="onSignInError">
						  <!-- Facebook登录 -->
					
						<div class="other pointer facebookstyle">
							<div class="other_left border-right2">
								<img class="icon_02" src="../../static/images/brand/facebook.png" alt="">
							</div>
							<div class="other_right">
								{{$t('m.login_07')}} Facebook {{$t('m.login_08')}}
							</div>
						</div>
					</fb-signin-button>

				</div>
			</div>
			<div class="agreement">
				* {{$t('m.login_11')}}
				<div class="orange pointer" @click="dialogVisible1 = true">{{$t('m.login_12')}}</div>
				，{{$t('m.login_13')}}
				<div class="pointer orange" @click="dialogVisible2=true">
					{{$t('m.login_14')}}
				</div>
			</div>
		</div>
		<!-- 谷歌登录弹出框 -->
		<el-dialog :visible.sync="Google_show" width="490px" center>
			<div class="showbox">
				<div class="log">
					<img src="../../static/images/google_logo.png" alt="">
				</div>
				<h2>登入</h2>
				<p>使用您的Google账号</p>
				<div class="from_box">
					<div class="inpu_box">
						<div class="inpu_title">
							电子邮件：
						</div>
						<div class="inpu_main">
							<el-input v-model="Google_data.mailbox" placeholder="请输入电子邮件"></el-input>
						</div>
					</div>
					<div class="inpu_box">
						<div class="inpu_title">
							<span>密</span><span>码：</span>
						</div>
						<div class="inpu_main">
							<el-input v-model="Google_data.password" placeholder="请输入密码"></el-input>
						</div>
					</div>
				</div>
				<div class="from_btnbox">
					<el-button type="danger" @click="Google_confirm">登录</el-button>
				</div>
			</div>
		</el-dialog>
		<!-- 完善信息弹出框 -->
		<el-dialog :visible.sync="perfect_show" width="550px" center>
			<div class="showbox">
				<h2>完善信息</h2>
				<div class="loginbox1">
					<div class="inp_item">
						<div class="inp_text">用户身份</div>
						<div class="inp_radiobox">
							<div class="inp_radio" v-for="(item, index) in radio_list" :key="index"
								@click="chang_radio(index)">
								<div class="radio pointer">
									<img v-show="item.Selected" src="../../static/xuanzhong.png" alt="">
									<img v-show="!item.Selected" src="../../static/images/weixuanzhonghuise.png" alt="">
									<div>{{ item.text }}</div>
								</div>
							</div>
						</div>
					</div>
					<div class="inp_item">
						<div class="inp_text">绑定电子邮箱：</div>
						<div class="inp_"><input placeholder="请输入绑定电子邮箱" v-model="param.mailbox"></div>
					</div>
					<div class="inp_item">
						<div class="inp_text">验证码：</div>
						<div class="inp_"><input class="yzm" v-model="param.code" placeholder="请输入验证码"></div>
						<div class="btn pointer" @click="getcode" v-if="!if_send">获取验证码</div>
						<div v-if="if_send" class="code_style">{{ code_time }}</div>
					</div>
					<div class="inp_item">
						<div class="inp_text">密码：</div>
						<div class="inp_"><input placeholder="请输入密码" v-model="param.password"></div>
					</div>
					<div class="inp_item">
						<div class="inp_text">再次输入密码：</div>
						<div class="inp_"><input placeholder="请再次输入密码" v-model="param.password1"></div>
					</div>
					<div class="inp_item" v-show="identity == 1">
						<div class="inp_text">电话</div>
						<div class="inp_"><input placeholder="请输入电话" v-model="param.phone"></div>
					</div>
					<div class="inp_item" v-show="identity == 2">
						<div class="inp_text">公司名</div>
						<div class="inp_"><input v-model="param.Companyname" placeholder="请输入公司名"></div>
					</div>
					<div class="inp_item" v-show="identity == 2">
						<div class="inp_text">税号</div>
						<div class="inp_"><input placeholder="请输入税号" v-model="param.tax_num"></div>
					</div>
					<div class="upload_item" v-show="identity == 2">
						<p>上传营业执照</p>
						<div class="upload_box">
							<el-upload action="https://jsonplaceholder.typicode.com/posts/" list-type="picture-card"
								:on-preview="handlePictureCardPreview" :on-remove="handleRemove">
								<img src="../../static/images/shanghcuan.png" alt="">
								<span>上传图片</span>
							</el-upload>
							<el-dialog :visible.sync="dialogVisible">
								<img width="100%" :src="dialogImageUrl" alt="">
							</el-dialog>
						</div>
					</div>
					<div class="btnbox" @click="confirm">
						<el-button type="danger">注册</el-button>
					</div>
				</div>
				<div class="agreement1">
					* 登入即表示您同意
					<div class="orange pointer">使用條款</div>
					，願意收取 哈芙游乐的電子郵件和最新資訊，並已閱讀
					<div class="pointer orange">隱私權政策</div>
				</div>
			</div>
		</el-dialog>
		<!-- 弹出框 -->
		<el-dialog :visible.sync="dialogVisible1" width="50%" @open="terms_of_use">
			<div class="show_title">
				{{content_tltle}}
			</div>
			<div class="tiaokuan" v-html="content"></div>
		</el-dialog>
		<!-- 弹出框 -->
		<el-dialog :visible.sync="dialogVisible2" width="50%" @open="privacy_policy">
			<div class="show_title">
				{{content_tltle1}}
			</div>
			<div class="tiaokuan" v-html="content1"></div>
		</el-dialog>
	
		
		<!-- <div class="g_id_signin" id="g_id_signin">111</div> -->
		
	<!-- 	<div id="g_id_onload"
			 data-client_id="244885048256-4jpnmjm99ppho7ks6i10imq07lqs63e6.apps.googleusercontent.com"
			 data-callback="handleCredentialResponse">
		</div>
		<div class="g_id_signin" ux_mode="redirect" data-type="standard"></div> -->
	
	</div>
</template>
<script>
	import GoogleSignInButton from 'vue-google-signin-button-directive'
	import encryption from '@/utils/encryption.js'
	import router from "@/router";

	export default {
		directives: {
		  GoogleSignInButton
		},
		data() {
			return {
				content: "", //使用条款详情
				content_tltle: '',
				content1: "", //隐私政策详情
				content_tltle1: '',
				dialogVisible1: false, //使用条款弹窗
				dialogVisible2: false, //
				screenHeight: '',
				user_data: {
					email: '',
					password: '',
				},
				Google_data: {
					mailbox: '',
					password: '',
				},
				Google_show: false,
				perfect_show: false,
				radio_list: [{
						id: 1,
						text: '个人',
						Selected: true
					},
					{
						id: 2,
						text: '公司',
						Selected: false
					}
				],
				identity: '1',
				dialogImageUrl: '', //本地路径
				dialogVisible: false,
				param: {
					mailbox: '',
					password: '',
					password1: '',
					phone: '',
					code: '',
					Companyname: '',
					tax_num: '',
				},
				code_time: 60, //验证码保护器
				if_send: false, //是否发送了验证码
				// 脸书
				fbSignInParams: {
				  scope: 'email,user_likes',
				  return_scopes: true
				},
				// 谷歌
				googleSignInParams: {
					client_id: "244885048256-4jpnmjm99ppho7ks6i10imq07lqs63e6.apps.googleusercontent.com"
				},
				// 是否邮箱登录
				is_yx:true
			}
		},
		beforeCreate() {
			  let script = document.createElement('script');
			  script.type = 'text/javascript';
			  script.src = './api_client.js';
			  document.body.appendChild(script);
			  console.log(666)
			  // let script1 = document.createElement('script');
			  // script1.type = 'text/javascript';
			  // script1.src = 'https://connect.facebook.net/zh_CN/sdk.js#xfbml=1&version=v3.3&appId=763593711432041&autoLogAppEvents=1';
			  // document.body.appendChild(script1);
		},
		mounted() {
			window.screenHeight = document.documentElement.clientHeight; //实时高度
			this.screenHeight = window.screenHeight - 80 - 25;
			let email = this.$router.currentRoute.query.email || ''
			if(email){
				this.user_data.email = email
			}else{
				if(localStorage.getItem('login_zh')){
					this.user_data.email = localStorage.getItem('login_zh')
				}
			}
		},
		created() {
			// 使用谷歌登录的api
			const script = document.createElement("script");
			script.src = "https://accounts.google.com/gsi/client"
			document.body.appendChild(script);
			

			// window.addEventListener('load', () => {
				
				setTimeout(()=>{
					window.google.accounts.id.initialize({
					    // 主要就是填写client_id
						client_id: "244885048256-4jpnmjm99ppho7ks6i10imq07lqs63e6.apps.googleusercontent.com",
						auto_select: false,
						callback: this.handleCredentialResponse,
					});
					// 设置按钮的样式等
					window.google.accounts.id.renderButton(
						document.getElementById("g_id_signin"),
						{
							theme: "filled_blue",
							size: 'large',
							width:'250',
							type: 'standard',
							text: 'signin_with'
						}
					);
				},500)
				
			// })
			
			
		},
		methods: {
			async handleCredentialResponse(response) {
				// 获取回调响应的凭证数据 然后拿这个凭证给后台，后台jwt进行解析获取登录信息
				console.log(response)
				var that = this
				var data = {credential:response.credential}
				let sing = encryption.getSing(data)
				this.$api.google_account_decode(data, sing).then(res => {
					if (res.data.code == 1) {
						that.login_other(2,res.data.data)
					}
				})
			},
			// 脸书
			onSignInSuccess (response) {
				console.log('facebook成功回调',response.authResponse.userID) //返回第三方的登录信息 tolen等
				this.login_other(1,response.authResponse.userID)
			},
			onSignInError (error) {
				//登录失败回调
				console.log('facebook失败回调',error) 
				this.$message.warning(this.$t('m.home_011'))
			},
			// 其它登录
			login_other(type,id){
				var data = {
					// 1facebook 2google
					type:type,
					third_id:id
				}
				let sing = encryption.getSing(data)
				this.$api.login_other(data, sing).then(res => {
					if (res.data.code == 1) {
						let user_data = res.data.data || []
						localStorage.setItem('user_data', JSON.stringify(user_data))
						this.$message.success(this.$t('m.login_15'))
						localStorage.setItem('login_zh', this.user_data.email)
						setTimeout(() => {
							this.$router.push({
								path: '/'
							})
						}, 2000);
					}else if(res.data.code == -2){
						//请先注册
						this.$router.push({
							path: '/account/register',
							query:{
								type:type,
								third_id:id
							}
						})
						
					}
				})
			}, 
			terms_of_use() {
				this.$api.terms_of_use().then((res) => {
					if (res.data.code == 1) {
						this.content = res.data.data.content
						this.content_tltle = res.data.data.title
					}
				})
			},
			privacy_policy() {
				this.$api.privacy_policy().then((res) => {
					if (res.data.code == 1) {
						this.content1 = res.data.data.content
						this.content_tltle1 = res.data.data.title
					}
				})
			},
			chang_radio(index) {
				this.radio_list.forEach(item => {
					item.Selected = false
				});
				this.radio_list[index].Selected = true
				this.identity = this.radio_list[index].id
			},
			//获取验证码
			getcode() {
				let that = this
				if (!this.param.mailbox) {
					this.$message.warning('请输入绑定的电子邮箱账号')
				} else {
					this.$message.success('验证码已发送至您的邮箱')
					this.if_send = true
					clearInterval(that.code_time);
					let timer = setInterval(() => {
						that.code_time--;
						if (that.code_time <= 0) {
							clearInterval(timer);
							that.if_send = false;
						}
					}, 1000);

				}
			},
			return_() {
				this.$router.push({
					path: '/'
				})
				// this.$router.go(-1)
			},
			register() {
				this.$router.push({
					path: '/account/register'
				})
			},
			RetrievePwd() {
				this.$router.push({
					path: '/account/RetrievePwd'
				})
			},
			handleRemove(file, fileList) {
				console.log('删除')
				console.log(file, fileList);
			},
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisible = true;
				console.log('查看')
			},
			Google_confirm() {
				if (!this.Google_data.mailbox) {
					this.$message.warning('请输入邮箱账号')
				} else if (!this.Google_data.password) {
					this.$message.warning('请输入密码')
				} else {
					this.Google_show = false
					this.perfect_show = true
				}
			},
			//登录
			confirm() {
				if (1) {
				// if (!this.user_data.email) {
				// 	this.$message.warning(this.$t('m.login_09'))
				// } else if (!this.user_data.password) {
				// 	this.$message.warning(this.$t('m.login_10'))
					
				// } else {
					var data = {
						password:this.user_data.password
					}
					// data.email = this.user_data.email
					data.mobile = this.user_data.email
					// if(this.is_yx){
					// 	data.login_type = 1
					// }else{
					// 	data.login_type = 2
					// }
					let sing = encryption.getSing(data)
					this.$api.login(data, sing).then(res => {
						if (res.data.code == 1) {
							console.log(res.data)
							let user_data = res.data.data || []
							localStorage.setItem('user_data', JSON.stringify(user_data))
							this.$message.success(this.$t('m.login_15'))
							localStorage.setItem('login_zh', this.user_data.email)
							// localStorage.setItem('login_pwd', this.user_data.password)
							setTimeout(() => {
								this.$router.push({
									path: '/'
								})
								// this.$router.go(-1)
							}, 2000);
						}
					})
				}
			},
		}
	}
</script>
<style lang="scss" scoped>
	.topkongbox {
		height: 15px;
	}
	.main {
		width: 100%;
		background-image: url(../../static/images/brand/login_bac.png);
		background-size: 100% 100%;
		border-top: 5px solid #ef5843;
		h1 {
			text-align: center;
			font-size: 40px;
		}
		.mainkongbox {
			width: 100%;
			height: 100px;
		}
		.zhuce {
			display: flex;
			align-items: center;
			justify-content: center;
			margin-top: 20px;
			font-size: 15px;
			font-weight: bold;
		}
		.loginbox {
			margin: 40px 0;
			display: flex;
			justify-content: center;
			.loginbox_left {
				width: 270px;
				padding: 40px 0;
				.forget {
					display: flex;
					justify-content: flex-end;
					margin-top: 10px;
					font-size: 14px;
				}
				.btnbox {
					margin-top: 20px;
					.el-button {
						font-weight: bold;
						width: 120px;
						height: 46px;
						background-color: #ef5843;
					}
				}
				.input_box1 {
					margin-top: 20px;
				}
				.input_box {
					.text {
						font-size: 15px;
					}
					.input {
						width: 270px;
						height: 36px;
						line-height: 30px;
						border-bottom: 1px solid #dad8d8;
						input {
							border: 0 !important;
							width: 100%;
							height: 36px;
							background-color: transparent;
							outline: none;
						}
					}
				}
			}
			.VerticalLine {
				width: 160px;
				display: flex;
				align-items: center;
				justify-content: center;
				.xian {
					width: 1px;
					height: 100%;
					background-color: #5c6069;
				}
			}
			.loginbox_right {
				width: 290px;
				padding: 40px 0;
				display: flex;
				justify-content: space-between;
				// flex-direction: column;
				flex-wrap: wrap;
				>div{
					margin: auto!important;
				}
				.other {
					display: flex;
					align-items: center;
					width: 260px;
					height: 50px;
					font-size: 14px;
					border-radius: 5px;
					.other_left {
						background-color: #fff;
						display: flex;
						align-items: center;
						justify-content: center;
						width: 58px;
						height: 46px;
						.icon_01 {
							width: 28px;
							height: 29px;
						}
						.icon_02 {
							width: 17px;
							height: 32px;
						}
						.icon_03 {
							width: 31px;
							height: 25px;
						}
					}
					.other_right1 {
						color: #000000 !important;
					}
					.other_right {
						color: #fff;
						flex: 1;
						text-align: center;
					}
				}
			}
		}
		.agreement {
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 12px;
		}
	}
	.agreement1 {
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 12px;
		white-space: nowrap;
		font-size: 10px;
	}
	.header {
		width: 100%;
		height: 90px;
		background-color: #FFF;
		display: flex;
		justify-content: space-between;
		padding: 0 145px;
		align-items: center;
		.logo {
			img {
				width: 90px;
				// height: 53.5px;
			}
		}
		.header_right {
			display: flex;
			align-items: center;
			img {
				width: 15px;
				height: 15px;
			}
		}
	}
	.gugestyle {
		border: 2px solid #4285f4;
		background-color: #4285f4;
	}
	.facebookstyle {
		border: 2px solid #3b5998;
		background-color: #3b5998;
	}
	.twitterstyle {
		border: 2px solid #000000;
		background-color: #fff;
		color: #000000 !important;
	}
	.border-right1 {
		border-right: 2px solid #4285f4;
	}
	.border-right2 {
		border-right: 2px solid #3b5998;
	}
	.border-right3 {
		border-right: 2px solid #000000;
	}
	::v-deep .el-dialog {
		background-color: #f6f7fa;
	}
	.showbox {
		padding-bottom: 20px;
		img {
			margin-top: 10px;
			width: 140px;
		}
		h2 {
			margin-top: 14px;
			font-size: 19px;
		}
		p {
			margin-top: 10px;
		}
		text-align: center;
		.from_box {
			margin: 0 auto;
			margin-top: 10px;
			width: 360px;
		}
		.from_btnbox {
			margin-top: 30px;
			width: 100%;
			::v-deep .el-button {
				background-color: #ef5843;
				width: 360px;
				height: 50px;
			}
		}
		.inpu_box {
			border: 1px solid #e5e5e5;
			width: 100%;
			margin-top: 20px;
			background-color: #fff;
			display: flex;
			align-items: center;
			border-radius: 4px;
			padding: 0 20px;
			height: 50px;
			line-height: 50px;
			.inpu_title {
				font-weight: bold;
				width: 75px;
				font-size: 14px;
				display: flex;
				justify-content: space-between;
			}
			.inpu_main {
				margin-left: 10px;
				flex: 1;
				::v-deep .el-input__inner {
					border: 0 !important;
					background-color: #fff;
				}
			}
		}
	}
	::v-deep .el-dialog__body {
		padding: 0 30px 30px 30px !important;
	}
	::v-deep .el-dialog__headerbtn .el-dialog__close {
		color: #2e3341;
		font-size: 24px;
		font-weight: bold;
	}
	.loginbox1 {
		// margin: 70px 0;
		width: 400px;
		margin: 30px auto;
		.btnbox {
			margin-top: 30px;
			width: 100%;
			::v-deep .el-button {
				width: 400px;
				height: 50px;
				background-color: #ef5843 !important;
			}
		}
		.upload_item {
			margin-top: 20px;
			width: 100%;
			p {
				font-weight: bold;
				font-size: 14px;
				padding: 0 20px;
				text-align: left !important;
			}
			.upload_box {
				margin-top: 20px;
				text-align: left !important;
				img {
					width: 32px;
					height: 32px;
				}
			}
		}
		::v-deep .el-upload--picture-card {
			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: column;
			line-height: normal;
			span {
				margin-top: 16px;
				color: #697185;
			}
		}
		::v-deep .el-upload--picture-card {
			border: 1px solid #e9e9ea;
		}
		.inp_item {
			border: 1px solid #e5e5e5;
			margin-top: 10px;
			display: flex;
			align-items: center;
			background-color: #fff;
			height: 50px;
			padding: 0 20px;
			width: 100%;
			.inp_radiobox {
				display: flex;
				align-items: center;
				flex: 1;
			}
			.code_style {
				color: #ef5843;
			}
			.inp_text {
				width: 110px;
				text-align: left !important;
				font-size: 14px;
				font-weight: bold;
			}
			.btn {
				width: 85px;
				height: 30px;
				display: flex;
				justify-content: center;
				align-items: center;
				font-size: 14px;
				background-color: #FFF;
				color: #ef5843;
				border: 2px solid #ef5843;
				border-radius: 4px;
			}
			.yzm {
				width: 100px !important;
			}
			.inp_radio {
				display: flex;
				align-items: center;
				.radio {
					display: flex;
					align-items: center;
					img {
						width: 18px;
						height: 18px;
						margin-bottom: 8px;
					}
					div {
						margin-left: 6px;
					}
				}
				.radio:last-child {
					margin-left: 30px;
				}
			}
			.inp_ {
				flex: 1;
				display: flex;
				input {
					border: 0 !important;
					margin-left: 10px;
					height: 56px;
					background-color: transparent;
					outline: none;
				}
			}
		}
	}
	::v-deep .el-button {
		font-weight: bold !important;
	}
	.tiaokuan {
		height: 60vh;
		overflow: auto;
	}
	.show_title {
		font-size: 36px;
		margin-bottom: 20px;
	}
	
	
// 宽度小于1200px
@media screen and (max-width: 1200px){
	.header{
		height: 2.5rem;
		padding: 0 1rem;
		.logo{
			img{
				width: 2.275rem;
				height: auto;
				display: block;
			}
		}
	}
	.topkongbox{
		height: 0;
	}
	.main{
		height: auto!important;
		margin: 1rem 0;
		margin-top: 0;
		margin-bottom: 0;
		.mainkongbox{
			height: 3rem!important;
		}
		.loginbox{
			display: block;
			margin: 1rem 0;
			.loginbox_left{
				padding: 0;
				margin: auto;
				.btnbox{
					margin-top: 2rem;
					::v-deep .el-button {
						margin: auto;
						display: block;
					}
				}
			}
			.loginbox_right{
				margin: auto;
				padding: 2rem 0;
				.g-signin-button{
					margin: auto;
					margin-bottom: 1rem;
				}
				.fb-signin-button{
					margin: auto;
				}
			}
		}
		.agreement{
			padding: 1rem ;
			padding-bottom: 4rem;
			display: block;
			.orange{
				display: inline-block;
			}
		}
	}
	::v-deep .el-dialog {
		// background-color: #f6f7fa;
		width: 90%!important;
		margin-top: 10%!important;
	}
	.input_box{
		.text{
			padding-bottom: 0.5rem!important;
		}
	}
}
.g_id_signin{
	width: 6.5rem;
	margin: auto;
	margin-bottom: 0.5rem;
}
.nsm7Bb-HzV7m-LgbsSe-BPrWId{
	color: #fff;
}
::v-deep .nsm7Bb-HzV7m-LgbsSe .nsm7Bb-HzV7m-LgbsSe-BPrWId{
	color: #fff!important;
}
::v-deep .nsm7Bb-HzV7m-LgbsSe.MFS4be-v3pZbf-Ia7Qfc{
	// height: 1.25rem;
}
</style>
